<template>
  <layout-page name="not-found" centered>
    <h1>Page introuvable!</h1>

    <div class="text-center">
      <b-button to="/">Retour à l'accueil</b-button>
    </div>
  </layout-page>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="scss"></style>
